import type { StudentCommunityRoutes } from 'ulanano-cms-api/routes/student-community'
import { createGranularTreaty } from '../api-factory'

export const studentCommunityApi = createGranularTreaty<StudentCommunityRoutes>({ withCookies: true })
